import { Trans } from 'next-i18next'
import styled from 'styled-components'

import { colors } from '@/styles'
import { Reveal } from '@/components/animations'
import { Group, Row } from '@/components/form'
import { Label } from '@/components/text'

import { ReactComponent as ExclamationCircle } from './images/exclamation-circle.svg'

const WarningBox = styled.div`
  padding: 12px;
  background-color: ${colors.grey96};
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  color: ${colors.black};
`

const RequirementTitle = styled(Label)`
  font-weight: 700;
  line-height: 16px;
`

const Requirement = styled(Label)`
  line-height: 16px;
  font-weight: 400;
  display: flex;
  align-items: center;
  gap: 8px;

  svg {
    width: 20px;
    height: 20px;
  }
`

type PasswordRequirementsProps = {
  requirements: Record<string, boolean>
  show: boolean
}

const PasswordRequirements: React.FC<PasswordRequirementsProps> = ({
  requirements,
  show
}) => {
  const passwordRequirementsMet = Object.values(requirements).every(Boolean)

  return (
    <Reveal isOpen={show && !passwordRequirementsMet}>
      <Row>
        <Group col={12}>
          <WarningBox>
            <Trans i18nKey="b.auth.edit.account_password_requirements.text">
              <RequirementTitle fontSize="12px">
                Your password must include:
              </RequirementTitle>
              <Reveal isOpen={!requirements?.one}>
                <Requirement fontSize="12px">
                  <ExclamationCircle />
                  Minimum 8 characters
                </Requirement>
              </Reveal>
              <Reveal isOpen={!requirements?.two}>
                <Requirement fontSize="12px">
                  <ExclamationCircle />
                  At least 1 number
                </Requirement>
              </Reveal>
              <Reveal isOpen={!requirements?.three}>
                <Requirement fontSize="12px">
                  <ExclamationCircle />
                  At least 1 alphabet letter
                </Requirement>
              </Reveal>
              <Reveal isOpen={!requirements?.four}>
                <Requirement fontSize="12px">
                  <ExclamationCircle />
                  At least 1 special character
                </Requirement>
              </Reveal>
            </Trans>
          </WarningBox>
        </Group>
      </Row>
    </Reveal>
  )
}

export default PasswordRequirements
